import { abbrNumberFilter } from "app/filters/ngFilters";
import type { IRange } from "app/pages/sales-intelligence/types/range";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { getRangeChipValue } from "../../../../utils";

const formatNumber = (value: number): string => abbrNumberFilter()(value);

function formatChipsContent(value: Partial<IRange<number>>): string | undefined {
    const { from, to } = value || {};

    const formattedFrom = is.undefined(from) ? "" : formatNumber(from);
    const formattedTo = is.undefined(to) ? "" : formatNumber(to);

    return getRangeChipValue({ from: formattedFrom, to: formattedTo }, false);
}

export default formatChipsContent;
